import { Directive, effect, input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[dynamicDisable]',
})
export class DynamicDisableControlDirective {
    dynamicDisable = input<boolean | undefined>();

    constructor(private ngControl: NgControl) {
        effect(() => {
            const dynamicDisable = this.dynamicDisable();
            if (this.ngControl.control && dynamicDisable !== undefined) {
                if (dynamicDisable) {
                    this.ngControl.control.disable();
                } else {
                    this.ngControl.control.enable();
                }
            }
        });
    }
}
